import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Table,
  InputNumber,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Card,
  message,
  notification,
  Typography,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import config from "../../util/ApiforContext";
import { useLocation } from "react-router-dom";
import ApprovalButtons from "../Forms/ApprovalButtons";
const { Option } = Select;
const { Title } = Typography;

const UpdateOrder = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [materialsData, setMaterialsData] = useState({
    data: [],
    loading: false,
  });
  const [rows, setRows] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quoteSelect, setQuoteSelect] = useState({
    data: [],
    loading: false,
  });

  const [purchaseRequestSelect, setPurchaseRequestSelect] = useState({
    data: [],
    loading: false,
  });

  const currencies = [
    { id: 1, code: "TRY", symbol: "₺" },
    { id: 2, code: "USD", symbol: "$" },
    { id: 3, code: "EUR", symbol: "€" },
  ];

  const [selectedCurrency, setSelectedCurrency] = useState(currencies[0]);
  const [materialAllListData, setMaterialAllListData] = useState({
    data: [],
    loading: false,
  });

  const [existingFiles, setExistingFiles] = useState([]);
  const [materlalCategorySelect, setMaterialCategorySelect] = useState({
    data: [],
    loading: false,
  });

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [disabledFirmSelect, setDisabledFirmSelect] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode") || "edit"; // default edit
  const isViewMode = mode === "view";
  const [data, setData] = useState({});

  const addRow = () => {
    setRows([
      ...rows,
      {
        key: Date.now(),
        stockId: null,
        name: "",
        stockCode: "",
        quantity: 0,
        unitPrice: 0,
        discount: 0,
        vat: 20, // default 20%
        unit: "",
        materialCategoryId: null,
        netAmount: 0,
        total: 0,
        taxRate: 0,
        deliveryDate: null,
      },
    ]);
  };

  const updateRow = (key, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.key === key) {
          let updatedRow = { ...row };

          // Sayısal alanlar için boşsa 0 ata
          if (
            ["quantity", "unitPrice", "discount", "vat"].includes(field) &&
            (value === null || value === undefined || value === "")
          ) {
            value = 0;
          }

          updatedRow[field] = value;

          // Material seçilince isim, kod, birim otomatik doldur
          if (field === "stockId" && value) {
            const selected = materialsData.data.find((m) => m.id === value);
            if (selected) {
              updatedRow.name = selected.name || "";
              updatedRow.stockCode = selected.stockCode || "";
              updatedRow.unit = selected.unit || "";
              updatedRow.materialCategoryId =
                selected.materialCategoryId || null;
              updatedRow.taxRate = selected.taxRate || 0;
            }
          }

          // NetAmount ve Total yeniden hesapla
          const quantity = updatedRow.quantity || 0;
          const unitPrice = updatedRow.unitPrice || 0;
          const discount = updatedRow.discount || 0;
          const vat = updatedRow.vat || 0;

          const netAmount = quantity * unitPrice - discount;
          const total = netAmount + (netAmount * vat) / 100;

          updatedRow.netAmount = netAmount;
          updatedRow.total = total;

          return updatedRow;
        }
        return row;
      }),
    );
  };

  const deleteRow = (key) => {
    setRows((prev) => prev.filter((row) => row.key !== key));
  };

  const columns = [
    {
      title: "Malzeme",
      dataIndex: "stockId",
      width: 180, // genişlik (px)
      render: (value, record) => (
        <Select
          placeholder="(Opsiyonel). En az 2 harf giriniz.."
          value={value}
          allowClear
          showSearch
          onSearch={onMaterialSearch}
          onChange={(val) => updateRow(record.key, "stockId", val)}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          disabled={isViewMode}
        >
          {materialsData?.data?.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Kategori",
      dataIndex: "materialCategoryId",
      render: (value, record) => (
        <Form.Item style={{ marginBottom: 0 }}>
          <Select
            placeholder="Kategori"
            value={value}
            allowClear
            disabled={true} // Malzeme seçiliyse readonly
            showSearch
            onSearch={onMaterialCategorySearch}
            onChange={(val) => updateRow(record.key, "materialCategoryId", val)}
            style={{ width: "100%" }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {materlalCategorySelect?.data?.map((m) => (
              <Option key={m.id} value={m.id}>
                {m.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
      width: 90,
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "quantity", val)}
          style={{ width: "100%" }}
          disabled={isViewMode}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
          precision={0}
        />
      ),
    },
    {
      title: "Tevkifat",
      dataIndex: "taxRate",
      key: "taxRate",
      align: "left",
      render: (data) => {
        return "%" + data;
      },
    },
    {
      title: "Birim",
      dataIndex: "unit",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true} // Malzeme seçiliyse readonly
          onChange={(e) => updateRow(record.key, "unit", e.target.value)}
        />
      ),
    },
    {
      title: "Birim Fiyat",
      dataIndex: "unitPrice",
      width: 110,
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "unitPrice", val)}
          style={{ width: "100%" }}
          formatter={(val) =>
            val !== undefined && val !== null && val !== ""
              ? `${selectedCurrency.symbol} ${Number(val).toFixed(2)}`
              : ""
          }
          parser={(val) => val.replace(/[^0-9.]/g, "")}
          disabled={isViewMode}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
        />
      ),
    },
    {
      title: "İskonto",
      dataIndex: "discount",
      width: 110,
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "discount", val)}
          style={{ width: "100%" }}
          formatter={(val) =>
            val !== undefined && val !== null && val !== ""
              ? `${selectedCurrency.symbol} ${Number(val).toFixed(2)}`
              : ""
          }
          parser={(val) => val.replace(/[^0-9.]/g, "")}
          disabled={isViewMode}
          className="ant-input"
          decimalSeparator=","
          thousandSeparator="."
        />
      ),
    },
    {
      title: "KDV (%)",
      dataIndex: "vat",
      width: 90,
      render: (value, record) => (
        <Select
          value={value}
          onChange={(val) => updateRow(record.key, "vat", val)}
          style={{ width: "100%" }}
          disabled={isViewMode}
        >
          {[0, 1, 8, 10, 20].map((v) => (
            <Option key={v} value={v}>
              {v}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      width: 110,
      render: (_, record) => {
        const quantity = record.quantity || 0;
        const unitPrice = record.unitPrice || 0;
        const discount = record.discount || 0;
        const netAmount = quantity * unitPrice - discount;
        return `${selectedCurrency.symbol} ${netAmount.toFixed(2)}`;
      },
    },
    {
      title: "Toplam",
      dataIndex: "total",
      width: 110,
      render: (_, record) => {
        const quantity = record.quantity || 0;
        const unitPrice = record.unitPrice || 0;
        const discount = record.discount || 0;
        const vat = record.vat || 0;
        const netAmount = quantity * unitPrice - discount;
        const total = netAmount + (netAmount * vat) / 100;
        return `${selectedCurrency.symbol} ${total.toFixed(2)}`;
      },
    },
    {
      title: "Teslimat Tarihi",
      dataIndex: "deliveryDate",
      width: 150,
      render: (value, record) => (
        <DatePicker
          format="DD/MM/YYYY"
          value={value ? (moment.isMoment(value) ? value : moment(value)) : null}
          onChange={(val) => updateRow(record.key, "deliveryDate", val)}
          style={{ width: "100%" }}
          placeholder="Tarih seçiniz"
          disabled={isViewMode}
          disabledDate={(current) => current && current < moment().startOf("day")}
        />
      ),
    },
    {
      title: "Sil",
      key: "action",
      width: 60,
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => deleteRow(record.key)}
          disabled={isViewMode}
        ></Button>
      ),
    },
  ];

  const onSuccess = () => {
    form.resetFields();
    setFiles([]);
    setTimeout(
      function () {
        history.push(`/order-list`);
      }.bind(this),
      2000,
    );
  };

  const onFinish = (values) => {
    // 1. Mükerrer (Duplicate) Kontrolü
    const stockCounts = {};
    const duplicateRows = [];

    rows.forEach((row) => {
      if (row.stockId) {
        // Eğer bu stockId daha önce görüldüyse count'u artır, yoksa 1 yap
        stockCounts[row.stockId] = (stockCounts[row.stockId] || 0) + 1;

        // Tam olarak 2. kez gördüğümüzde listeye ekliyoruz.
        // (Böylece 3 veya 4 kez eklenmişse aynı hata mesajını defalarca basmayız)
        if (stockCounts[row.stockId] === 2) {
          duplicateRows.push(row);
        }
      }
    });

    if (duplicateRows.length > 0) {
      duplicateRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Mükerrer Ürün",
          description: `${row.name} malzemesi listede birden çok bulunuyor. Lütfen kontrol ediniz.`,
          placement: "topRight",
        });
      });
      return; // Hata varsa işlemi durdur
    }

    // Hatalı satırları tespit et
    const invalidRows = rows.filter((row) => {
      const hasMaterial = row.stockId || (row.name && row.name.trim() !== "");
      const validQuantity =
        typeof row.quantity === "number" && row.quantity > 0;

      const invalidTotal = row.total <= 0;
      return !hasMaterial || !validQuantity || invalidTotal;
    });

    if (invalidRows.length > 0) {
      invalidRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Hatalı Malzeme Satırı",
          description:
            row.name && row.name.trim() !== ""
              ? `${row.name} satırında eksik veya hatalı bilgi var.`
              : `Malzeme Adı belirtilmemiş satırda eksik veya hatalı bilgi var.`,
          placement: "topRight",
        });
      });
      return; // Hatalıysa devam etme
    }

    const updatedRows = rows.map((row) => ({
      ...row,
      currencyId: selectedCurrency.id,
      deliveryDate: row.deliveryDate
        ? (moment.isMoment(row.deliveryDate) ? row.deliveryDate.format("YYYY-MM-DD") : moment(row.deliveryDate).format("YYYY-MM-DD"))
        : null,
    }));

    // Her şey uygunsa payload hazırla
    const payload = {
      ...values,
      orderDate: values.orderDate
        ? values.orderDate.format("YYYY-MM-DD")
        : null,
      orderItemUpdateDtos: updatedRows,
      documentVms: existingFiles,
    };

    const formData = new FormData();
    formData.append("jsonString", JSON.stringify(payload));
    // Files alanı: her dosyayı ayrı ayrı 'Files' olarak append et
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    // API isteği (axios veya kendi RequestHandler’a göre)
    RequestHandler.put(
      `/Order`,
      formData,
      true,
      {},
      "multipart/form-data",
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onMaterialSearch = (value) => {
    if (value.length >= 2) {
      setMaterialsData({ data: [], loading: true });

      RequestHandler.get(
        `/Material?$select=id,name,code,materialCategoryId,materialCategoryName&$filter=${odata.contains(
          "name",
          value,
        )} or ${odata.contains("code", value)}`,
      ).then((res) => {
        setMaterialsData({ data: res.value, loading: false });
      });
    } else {
      setMaterialsData({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onQuoteSearch = (value) => {
    if (value.length >= 2) {
      setQuoteSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Order/GetQuoteList?$select=id,name,firmId,firmName&$filter=(${odata.contains(
          "name",
          value,
        )} or ${odata.contains("description", value)})  and Name ne 'Diğer'`,
      ).then((res) => {
        setQuoteSelect({ data: res, loading: false });
      });
    } else {
      setQuoteSelect({ data: [], loading: false });
    }
  };

  const onPurchaseRequestSearch = (value) => {
    if (value.length >= 2) {
      setPurchaseRequestSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Order/PurchaseRequest?$select=id,name,firmId,firmName,statusByte&$filter=(${odata.contains(
          "name",
          value,
        )} or ${odata.contains(
          "description",
          value,
        )})  and Name ne 'Diğer' and statusByte eq 2`,
      ).then((res) => {
        setPurchaseRequestSelect({ data: res, loading: false });
      });
    } else {
      setPurchaseRequestSelect({ data: [], loading: false });
    }
  };

  const summary = () => {
    const malHizmetToplam = rows.reduce(
      (sum, r) => sum + (r.quantity || 0) * (r.unitPrice || 0),
      0,
    );
    const toplamIskonto = rows.reduce((sum, r) => sum + (r.discount || 0), 0);
    const hesaplananKDV = rows.reduce((sum, r) => {
      const net = (r.quantity || 0) * (r.unitPrice || 0) - (r.discount || 0);
      return sum + net * ((r.vat || 0) / 100);
    }, 0);
    const vergilerDahilToplam = rows.reduce((sum, r) => {
      const net = (r.quantity || 0) * (r.unitPrice || 0) - (r.discount || 0);
      const total = net + net * ((r.vat || 0) / 100);
      return sum + total;
    }, 0);

    const toplamOdenecek = vergilerDahilToplam; // İstersen farklı hesaplama da olabilir.

    return (
      <div style={{ textAlign: "right", marginTop: 12, fontWeight: "bold" }}>
        <div>
          Mal Hizmet Toplam Tutarı: {selectedCurrency.symbol}{" "}
          {malHizmetToplam.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Toplam İskonto: {selectedCurrency.symbol} {toplamIskonto.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Hesaplanan KDV: {selectedCurrency.symbol} {hesaplananKDV.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Vergiler Dahil Toplam Tutar: {selectedCurrency.symbol}{" "}
          {vergilerDahilToplam.toFixed(2)}
        </div>
        <div style={{ marginTop: 8 }}>
          Toplam Ödenecek Tutar: {selectedCurrency.symbol}{" "}
          {toplamOdenecek.toFixed(2)}
        </div>
      </div>
    );
  };

  const onPurchaseRequestChange = (value) => {
    if (!value) {
      // Seçim temizlendiyse rows'u boşalt
      setRows([]);
      setDisabledFirmSelect(false);
      return;
    }

    // API çağrısı yapılıyor
    RequestHandler.get(
      `/Order/GetPurchaseRequestItemsByPurchaseRequestId/${value}`,
    )
      .then((response) => {
        if (response) {
          const data = response;
          if (Array.isArray(data) && data.length > 0) {
            // Gelen veriyi rows formatına uyarlayalım
            const newRows = data.map((item) => ({
              key: item.id || Date.now(), // id varsa kullan yoksa timestamp
              stockId: item.stockId || null,
              name: item.name || "",
              stockCode: item.stockCode,
              quantity: item.quantity || 0,
              unit: item.unit || "",
              unitPrice: 0, // default sıfır, sonra kullanıcı girecek
              discount: 0,
              vat: 20, // default KDV 20
              materialCategoryId: item.materialCategoryId || null,
              taxRate: item.taxRate || 0,
            }));

            setRows(newRows);
            form.setFieldsValue({
              quoteId: null,
            });
            const stockIds = (data || [])
              .map((item) => item.stockId)
              .filter(Boolean); // null/undefined olanları çıkar

            if (stockIds.length > 0) {
              // 4. OData filter string (Guid için)
              const filter = `id in (${stockIds
                .map((id) => `'${id}'`)
                .join(",")})`;

              // 5. İlgili Stock kayıtlarını çek
              RequestHandler.get(
                `/Order/GetStockList?$filter=${encodeURIComponent(filter)}`,
              ).then((stockResponse) => {
                if (stockResponse) {
                  setMaterialsData({
                    data: stockResponse,
                    loading: false,
                  });
                } else {
                  setMaterialsData({ data: [], loading: false });
                }
              });
            } else {
              // hiç stockId yoksa boş dön
              setMaterialsData({ data: [], loading: false });
            }
          } else {
            // Boş liste geldiğinde rows'u temizle
            setRows([]);
          }
        } else {
          // Yanıt beklenmedik ise rows boşalt
          setRows([]);
        }
      })
      .catch((error) => {
        console.error("API çağrısı hatası:", error);
        // Hata durumunda rows'u boşaltabiliriz veya kullanıcıya mesaj gösterebiliriz
        setRows([]);
      });

    // Talep ile ilişkili firmayı da getirip form'a set et
    // ayriyetten firma select'ini disable et.
    const selectedPR = purchaseRequestSelect.data.find((pr) => pr.id === value);
    if (selectedPR) {
      form.setFieldsValue({ firmId: selectedPR.firmId || null });
      if (selectedPR.firmId) {
        // Firma ID'sine göre firma bilgilerini getir
        RequestHandler.get(
          `/Order/GetFirmList?$select=id,firmBranchNumber,name&$filter=id eq ${selectedPR.firmId}`,
        ).then((res) => {
          if (res && res?.length > 0) {
            setFirmSelect({ data: res, loading: false });
            form.setFieldsValue({ firmId: res[0].id });
            setDisabledFirmSelect(true);
          }
        });
      } else {
        setDisabledFirmSelect(false);
      }
    } else {
      setDisabledFirmSelect(false);
    }
  };

  const onQuoteChange = (value) => {
    if (!value) {
      // Seçim temizlendiyse rows'u boşalt
      setRows([]);
      setDisabledFirmSelect(false);
      return;
    }

    // API çağrısı yapılıyor
    RequestHandler.get(`/Order/GetQuoteItemsByQuoteId/${value}`)
      .then((response) => {
        if (response) {
          const data = response;
          if (Array.isArray(data) && data.length > 0) {
            // Gelen veriyi rows formatına uyarlayalım
            const newRows = data.map((item) => ({
              key: item.id || Date.now(), // id varsa kullan yoksa timestamp
              stockId: item.stockId || null,
              name: item.name || "",
              stockCode: item.stockCode, // API’den yoksa boş bırakabilirsin
              quantity: item.quantity || 0,
              unit: item.unit || "",
              unitPrice: item.unitPrice || 0, // default sıfır, sonra kullanıcı girecek
              discount: item.discount || 0,
              vat: item.vat || 0, // default KDV 20
              materialCategoryId: item.materialCategoryId || null,
              taxRate: item.taxRate || 0,
            }));

            setRows(newRows);
            form.setFieldsValue({
              purchaseRequestId: null,
            });
            const stockIds = (data || [])
              .map((item) => item.stockId)
              .filter(Boolean); // null/undefined olanları çıkar

            if (stockIds.length > 0) {
              // 4. OData filter string (Guid için)
              const filter = `id in (${stockIds
                .map((id) => `'${id}'`)
                .join(",")})`;

              // 5. İlgili Stock kayıtlarını çek
              RequestHandler.get(
                `/Order/GetStockList?$filter=${encodeURIComponent(filter)}`,
              ).then((stockResponse) => {
                if (stockResponse) {
                  setMaterialsData({
                    data: stockResponse,
                    loading: false,
                  });
                } else {
                  setMaterialsData({ data: [], loading: false });
                }
              });
            } else {
              // hiç stockId yoksa boş dön
              setMaterialsData({ data: [], loading: false });
            }

            if (data.length > 0) {
              var currency = currencies.find(
                (c) => c.id === data[0].currencyId,
              );
              setSelectedCurrency(currency);
              form.setFieldsValue({
                currency: currency.code,
              });
            }
          } else {
            // Boş liste geldiğinde rows'u temizle
            setRows([]);
          }
        } else {
          // Yanıt beklenmedik ise rows boşalt
          setRows([]);
        }
      })
      .catch((error) => {
        console.error("API çağrısı hatası:", error);
        // Hata durumunda rows'u boşaltabiliriz veya kullanıcıya mesaj gösterebiliriz
        setRows([]);
      });

    // Teklif ile ilişkili firmayı da getirip form'a set et
    // ayriyetten firma select'ini disable et.
    const selectedQuote = quoteSelect.data.find((q) => q.id === value);
    if (selectedQuote) {
      form.setFieldsValue({ firmId: selectedQuote.firmId || null });
      if (selectedQuote.firmId) {
        // Firma ID'sine göre firma bilgilerini getir
        RequestHandler.get(
          `/Order/GetFirmList?$select=id,firmBranchNumber,name&$filter=id eq ${selectedQuote?.firmId}`,
        ).then((res) => {
          if (res && res?.length > 0) {
            setFirmSelect({ data: res, loading: false });
            form.setFieldsValue({ firmId: res[0]?.id });
            setDisabledFirmSelect(true);
          }
        });
      } else {
        setDisabledFirmSelect(false);
      }
    } else {
      setDisabledFirmSelect(false);
    }
  };

  useEffect(() => {
    // Eğer ID varsa, güncelleme için veriyi çek
    if (props.match.params.id) {
      RequestHandler.get(`/MaterialCategory`).then((response) => {
        setMaterialCategorySelect({
          data: response?.value,
          loading: false,
        });
      });

      RequestHandler.get(`/Order/GetById/${props.match.params.id}`).then(
        (response) => {
          if (response) {
            const data = response;
            setData(response);
            //#region

            if (data.purchaseRequestId) {
              RequestHandler.get(
                `/Order/GetPurchaseRequestById/${data?.purchaseRequestId}`,
              ).then((response) => {
                if (response) {
                  const purchaseRequestData = response;
                  setPurchaseRequestSelect({
                    data: [
                      {
                        id: purchaseRequestData.id,
                        name: purchaseRequestData.name,
                      },
                    ],
                    loading: false,
                  });
                }
              });
            }

            if (data.quoteId) {
              RequestHandler.get(`/Quote/GetById/${data?.quoteId}`).then(
                (response) => {
                  if (response) {
                    const quoteData = response;
                    setQuoteSelect({
                      data: [
                        {
                          id: quoteData.id,
                          name: quoteData.name,
                        },
                      ],
                      loading: false,
                    });
                  }
                },
              );
            }

            //#endregion

            form.setFieldsValue({
              name: data?.name,
              description: data?.description,
              orderDate: data?.orderDate ? moment(data?.orderDate) : null,
              id: data?.id,
              quoteId: data?.quoteId,
              purchaseRequestId: data?.purchaseRequestId,
              deliveryStatus: data?.deliveryStatus,
              firmId: data?.firmId,
            });
            setRows(
              (data.orderItems || []).map((item) => ({
                ...item,
                key: item.id || Date.now() + Math.random(),
                deliveryDate: item.deliveryDate ? moment(item.deliveryDate) : null,
              })),
            );
            // Eğer en az 1 tane item varsa currencyId'yi set et
            if (data.orderItems && data.orderItems.length > 0) {
              var currency = currencies.find(
                (c) => c.id === data.orderItems[0].currencyId,
              );
              setSelectedCurrency(currency);
            }
            setExistingFiles(data.files || []);

            const stockIds = (data.orderItems || [])
              .map((item) => item.stockId)
              .filter(Boolean); // null/undefined olanları çıkar

            if (stockIds.length > 0) {
              // 4. OData filter string (Guid için)
              const filter = `id in (${stockIds
                .map((id) => `'${id}'`)
                .join(",")})`;

              // 5. İlgili Stock kayıtlarını çek
              RequestHandler.get(
                `/Order/GetStockList?$filter=${encodeURIComponent(filter)}`,
              ).then((stockResponse) => {
                if (stockResponse) {
                  setMaterialsData({
                    data: stockResponse,
                    loading: false,
                  });
                } else {
                  setMaterialsData({ data: [], loading: false });
                }
              });
            } else {
              // hiç stockId yoksa boş dön
              setMaterialsData({ data: [], loading: false });
            }

            if (data?.firmId != undefined && data?.firmId != null) {
              RequestHandler.get(`/Order/GetByFirmId/${data?.firmId}`).then(
                (response) => {
                  setFirmSelect({
                    data: [response],
                    loading: false,
                  });

                  if (data?.quoteId || data?.purchaseRequestId) {
                    setDisabledFirmSelect(true);
                  }
                },
              );
            }
          } else {
            message.error("Talep verileri alınamadı.");
          }
        },
      );
    } else {
      // Uyarı ver
      notification.warning({
        message: "Uyarı",
        description: "Güncelleme için geçerli bir sipariş kaydı bulunamadı.",
      });
      onSuccess();
    }
  }, [props.match.params.id]);

  const fileDownload = (file) => {
    window.open(
      `${config.apiUrl}/FileDownload/${file}?t=${RequestHandler.getToken()}`,
    );
  };

  const onMaterialCategorySearch = (value) => {
    if (value.length >= 2) {
      setMaterialCategorySelect({ data: [], loading: true });

      RequestHandler.get(
        `/MaterialCategory?$select=id,name,code&$filter=(${odata.contains(
          "name",
          value,
        )} or ${odata.contains("code", value)})  and Name ne 'Diğer'`,
      ).then((res) => {
        setMaterialCategorySelect({ data: res.value, loading: false });
      });
    } else {
      setMaterialCategorySelect({ data: [], loading: false });
    }
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Order/GetFirmList?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value,
        )} or ${odata.contains("firmBranchNumber", value)}`,
      ).then((res) => {
        setFirmSelect({ data: res, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  return (
    <>
      <Title level={3}>Sipariş Güncelleme</Title>
      <Form
        form={form}
        name="update-order"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row justify="center" style={{ padding: 20, paddingLeft: "20%" }}>
          <Col xs={24} md={20} lg={24}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Row gutter={[16, 16]}>
                {/* Sol taraf */}
                <Col xs={24} md={18}>
                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Sipariş Bilgileri
                      </span>
                    }
                    bordered={false}
                  >
                    <Form.Item
                      label="Sipariş Kodu :"
                      name="name"
                      rules={[
                        { required: true, message: "Lütfen adı giriniz" },
                      ]}
                    >
                      <Input disabled={isViewMode} />
                    </Form.Item>
                    <Form.Item
                      label="Açıklama"
                      name="description"
                      // rules={[{ required: true, message: "Lütfen Açıklama giriniz" }]}
                    >
                      <Input.TextArea rows={3} disabled={isViewMode} />
                    </Form.Item>

                    <Col span={24}>
                      <div style={{ display: "flex", gap: "16px" }}>
                        <Form.Item
                          label="Teslimat Tarihi :"
                          name="orderDate"
                          style={{ flex: 1 }}
                        >
                          <DatePicker
                            format="YYYY-MM-DD"
                            style={{ width: "60%" }}
                            disabledDate={(current) => {
                              return (
                                current && current < moment().startOf("day")
                              );
                            }}
                            disabled={isViewMode}
                          />
                        </Form.Item>

                        <Form.Item
                          label="Teslimat Durumu :"
                          name="deliveryStatus"
                          style={{ width: "50%" }}
                        >
                          <Input.TextArea rows={3} disabled={isViewMode} />
                        </Form.Item>
                      </div>
                    </Col>

                    <Form.Item name="purchaseRequestId" label="Talep :">
                      <Select
                        allowClear
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onPurchaseRequestSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={purchaseRequestSelect.loading}
                        onChange={onPurchaseRequestChange}
                        disabled={isViewMode}
                      >
                        {purchaseRequestSelect?.data?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            name={item.name}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="quoteId"
                      label="Teklif :"
                      // rules={[
                      //   { required: true, message: "Lütfen Ana Depo seçiniz." },
                      // ]}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onQuoteSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={quoteSelect.loading}
                        onChange={onQuoteChange}
                        disabled={isViewMode}
                      >
                        {quoteSelect?.data?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            name={item.name}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item label="Proje Adı/Ünvanı :" name="firmId">
                      <Select
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onFirmSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={firmSelect.loading}
                        disabled={disabledFirmSelect || isViewMode}
                      >
                        {firmSelect.data.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            code={item.firmBranchNumber}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Sipariş Malzemeleri
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16, width: "125%" }}
                  >
                    <Form.Item
                      label="Para Birimi"
                      name="currency"
                      initialValue={selectedCurrency.code}
                    >
                      <Select
                        value={selectedCurrency.code}
                        onChange={(code) => {
                          const cur = currencies.find((c) => c.code === code);
                          if (cur) setSelectedCurrency(cur);

                          // Aynı zamanda satırların currencyId'sini güncelle (opsiyonel)
                          setRows((prev) =>
                            prev.map((row) => ({
                              ...row,
                              currencyId: cur.id,
                            })),
                          );
                        }}
                        style={{ width: 120 }}
                        disabled={isViewMode}
                      >
                        {currencies.map((cur) => (
                          <Option key={cur.id} value={cur.code}>
                            {cur.code}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 10, flexWrap: "wrap" }}>
                      <Button
                        type="dashed"
                        onClick={addRow}
                        icon={<PlusOutlined />}
                        disabled={isViewMode}
                      >
                        Satır Ekle
                      </Button>
                      {!isViewMode && (
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <CalendarOutlined />
                          <span>Tüm satırlara uygula:</span>
                          <DatePicker
                            format="DD/MM/YYYY"
                            placeholder="Tarih seçiniz"
                            disabledDate={(current) => current && current < moment().startOf("day")}
                            onChange={(val) => {
                              if (val) {
                                setRows((prev) => prev.map((row) => ({ ...row, deliveryDate: val })));
                              }
                            }}
                            style={{ width: 160 }}
                          />
                        </div>
                      )}
                    </div>
                    <Table
                      columns={columns}
                      dataSource={rows}
                      pagination={false}
                      rowKey="key"
                      scroll={{ x: "max-content" }}
                      footer={summary}
                    />
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Dosyalar
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16 }}
                  >
                    {/* API'den gelen dosyalar */}
                    {existingFiles.length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        {existingFiles.map((file) => (
                          <div
                            key={file.id}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              border: "1px solid #ddd",
                              padding: "8px 12px",
                              marginBottom: 8,
                              borderRadius: 4,
                            }}
                          >
                            <span>{file.fileName.split("\\").pop()}</span>
                            <div>
                              <Button
                                type="link"
                                onClick={() => fileDownload(file.fileName)}
                              >
                                İndir
                              </Button>
                              <Button
                                type="link"
                                danger
                                onClick={() =>
                                  setExistingFiles((prev) =>
                                    prev.filter((f) => f.id !== file.id),
                                  )
                                }
                                hidden={isViewMode}
                              >
                                Sil
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Yeni dosya yükleme alanı */}
                    <Upload
                      multiple
                      beforeUpload={() => false}
                      onChange={({ fileList }) => setFiles(fileList)}
                      fileList={files}
                    >
                      <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                    </Upload>
                  </Card>

                  {!isViewMode && (
                    <Row justify="space-between">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          icon={<PlusOutlined />}
                          htmlType="submit"
                          loading={loading}
                        >
                          Sipariş Güncelle
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        {/* En altta, View Mode’da gösterilecek */}
        {isViewMode && (
          <ApprovalButtons
            entityId={data?.id}
            entityType="order"
            status={data?.statusByte}
            canApprove={data?.canApprove}
            canReject={data?.canReject}
            canCancel={data?.canCancel}
            isAdmin={data?.isAdmin}
            onSuccess={onSuccess}
            form={form}
            documentVms={existingFiles}
            files={files}
          />
        )}
      </Form>
    </>
  );
};

export default UpdateOrder;
